import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { renderDollar, renderDollarDisabled, renderNumberPercentage } from '../../../../Utils/renderField/renderField';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import classNames from 'classnames';

const calculateAdministrativeData = (fields) => {
    if (!fields || fields.length === 0) return;

    fields.forEach((item, index) => {
        const isInitialYear = index === 0;

        if (isInitialYear) {
            // Para el primer año, usamos el valor_final como está, ya que es el valor base.
            item.value_final = item.value_final;
        } else {
            // Para los siguientes años, calcular usando crecimiento e inflación
            const prevItem = fields[index - 1];
            const growthMultiplier = 1 + (item.growth_percentage / 100);
            const inflationMultiplier = 1 + (item.inflation_percentage / 100);
            item.value_final = prevItem.value_final * growthMultiplier * inflationMultiplier;
        }
    });
};

const AdministrativeProjectionTable = ({ fields, years }) => {
    if (!years || years.length === 0) {
        return <div>No hay datos de años disponibles</div>;
    }

    return (
        <div className="table-responsive">
            <table className="table table-bordered text-center">
                <thead>
                    <tr className="table-header">
                        <th>Concepto</th>
                        {years.map((year, index) => (
                            <th key={`year-${year}-${index}`} className='text-right-padded-lg'>{year}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ textAlign: 'left', paddingLeft: '22px' }}>Proyección ($)</td>
                        {fields.map((field, index) => (
                            <td key={index} style={{ textAlign: 'right', paddingRight: '22px' }}>
                                <Field
                                    name={`${field}.value_final`}
                                    component={renderDollarDisabled}
                                    placeholder="$0.00"
                                    prefix="$"
                                    className="form-control text-right"
                                    style={{ textAlign: 'right' }}
                                />
                            </td>
                        ))}
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left', paddingLeft: '22px' }}>Crecimiento (%)</td>
                        {fields.map((field, index) => (
                            <td key={index} style={{ textAlign: 'right', paddingRight: '22px' }}>
                                {index > 0 && (
                                    <Field
                                        name={`${field}.growth_percentage`}
                                        component={renderNumberPercentage}
                                        placeholder="0%"
                                        className="form-control text-right"
                                        style={{ textAlign: 'right' }}
                                    />
                                )}
                            </td>
                        ))}
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

const AdministrativeAnnualProjections = props => {
    const { data, admin_data_state } = props;
    calculateAdministrativeData(admin_data_state);
    
    if (!data || !data.results) {
        return <div>Cargando datos...</div>;
    }

    const { results } = data;
    const projections = results.projections || [];
    const years = results.years || [];

    if (projections.length === 0 || years.length === 0) {
        return <div>Cargando datos de proyecciones...</div>;
    }

    const initializeProjectionData = (fields) => {
        if (fields.length === 0) {
            projections.forEach((data) => {
                fields.push(data);
            });
        }
    };

    return (
        <div className="administrative-annual-projections-container">
            <form onSubmit={props.handleSubmit}>
                <h4>Proyecciones anuales de administración</h4>
                <FieldArray
                    name="projections"
                    component={AdministrativeProjectionTable}
                    years={years}
                    rerenderOnEveryChange={true}
                    props={{ initializeProjectionData }}
                />

                <div className='buttons-box mt-5'>
                    <button type="submit"
                        className="btn btn-primary m-4 btn-modal"
                    >
                        GUARDAR
                    </button>
                </div>
            </form>
        </div>
    );
};

const formName = 'FormAdministrative';

const selector = formValueSelector(formName);

const mapStateToProps = (state) => {
    const admin_data_state = selector(state, 'projections');
    return {
        admin_data_state,
    };
};

export default connect(mapStateToProps)(
    reduxForm({
        form: formName,
    })(AdministrativeAnnualProjections)
);
